
<div class="dropdown">
  <a  class="nav-link dropdown-toggle"  href="#" role="button"  data-bs-toggle="dropdown" aria-expanded="false" id="dropdownMenuAboutUs">
        <div class="d-none d-md-block"><i class='fa fa-compass'></i> </div>
        <i class='fa fa-compass d-md-none'></i>
        About <span class="caret"></span></a>

    <div class="dropdown-menu" role="menu" aria-labelledby="dropdownMenuAboutUs">
        <a [routerLink]="['static/display/our/story']"  class="dropdown-item">Our Story</a>
        <a [routerLink]="['static/display/core/team']"  class="dropdown-item">Core Team</a>
    </div>

  </div>

